/* rt-revacc-swipe — o swipe da fila de avis (snippets/rt-reviews-accordion.liquid).
   Serve a PDP e a janela de quick-add (ligado pelo rt-quick-add.js).
   A animação CSS fica (corre no compositor; em JS com scrollLeft o iPhone engasgava). O dedo pausa
   as animações das duas listas e "arrasta o relógio": currentTime anda na proporção dos px, com
   módulo da duração, por isso o loop é contínuo nos dois sentidos. Ao largar há uma inércia curta
   e, `data-resume` s depois, play(). */
(function () {
  if (window.rtRevaccSwipe) return;
  window.rtRevaccSwipe = function (el) {
    if (el.dataset.rtSwipe) return;
    el.dataset.rtSwipe = '1';
    var row = el.querySelector('.rt-revacc__row');
    var track = row && row.querySelector('.rt-revacc__track');
    if (!track || !track.getAnimations) return;
    var delay = (parseFloat(el.dataset.resume) || 2) * 1000;
    var anims = [], start = null, dragging = false, moved = false, lastX = 0, lastT = 0, v = 0, timer = 0, raf = 0;

    function list() {
      return Array.prototype.concat.apply([], Array.prototype.map.call(row.querySelectorAll('.rt-revacc__track'), function (t) { return t.getAnimations(); }));
    }
    function shift(px) {
      if (!anims.length) return;
      var d = anims[0].effect.getComputedTiming().duration;
      var w = track.offsetWidth;
      if (!d || !w) return;
      var t = ((anims[0].currentTime - px * d / w) % d + d) % d;
      anims.forEach(function (a) { a.currentTime = t; });
    }
    function resumeLater() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        anims.forEach(function (a) { if (a.playState === 'paused') a.play(); });
      }, delay);
    }
    function coast() {
      v *= 0.94;
      if (Math.abs(v) < 0.02) { raf = 0; resumeLater(); return; }
      shift(v * 16);
      raf = requestAnimationFrame(coast);
    }

    row.addEventListener('pointerdown', function (e) {
      if (e.button > 0) return;
      anims = list();
      if (!anims.length) return;
      if (e.pointerType === 'mouse') e.preventDefault();
      clearTimeout(timer);
      cancelAnimationFrame(raf);
      anims.forEach(function (a) { a.pause(); });
      start = { x: e.clientX, y: e.clientY, id: e.pointerId };
      dragging = moved = false;
      lastX = e.clientX; lastT = e.timeStamp; v = 0;
    });
    row.addEventListener('pointermove', function (e) {
      if (!start || e.pointerId !== start.id) return;
      if (!dragging) {
        var dx = Math.abs(e.clientX - start.x), dy = Math.abs(e.clientY - start.y);
        if (dx < 6 || dx < dy) return;
        dragging = moved = true;
        row.classList.add('is-dragging');
        try { row.setPointerCapture(e.pointerId); } catch (err) {}
      }
      var step = e.clientX - lastX, dt = e.timeStamp - lastT;
      if (dt > 0) v = v * 0.2 + (step / dt) * 0.8;
      lastX = e.clientX; lastT = e.timeStamp;
      shift(step);
    });
    function end(e) {
      if (!start || e.pointerId !== start.id) return;
      start = null;
      row.classList.remove('is-dragging');
      if (dragging && e.type === 'pointerup' && e.timeStamp - lastT < 80) { raf = requestAnimationFrame(coast); }
      else resumeLater();
      dragging = false;
    }
    row.addEventListener('pointerup', end);
    row.addEventListener('pointercancel', end);
    row.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  };
})();
